import styled from 'styled-components';
import { teko } from '../../../utils/theme';

import { mobile } from '../../../utils/breakpoints';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  font-size: 22px;
  padding: 50px 0 50px 0;
  text-align: center;
  background-image: url('${({ background }) => background}');
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  ${teko};
`;

export const Headline = styled.h3`
  text-align: center;
  color: #ffffff;
  font-size: 45px;
  font-weight: 500;
  letter-spacing: 3.58px;
  line-height: 51px;

  @media (max-width: ${mobile.max}px) {
    font-size: 45px;
    line-height: 28px;
    letter-spacing: initial;
  }
`;

export const TimerEle = styled.div`
  display: inline-block;

  .time {
    font-size: 90px;
    text-align: center;
    margin-bottom: 16px;
    color: #${({ color }) => color};
    text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
  }

  .label {
    font-size: 26px;
    text-align: center;
    padding-right: 3px;
    color: #${({ color }) => color || '#000000'};
    text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
  }
  
  @media (max-width: ${mobile.max}px) {
    .time {
      font-size: 32px;
    }
    
    .label {
      font-size: 18px;
    }
  }
`;

export const Divider = styled.div`
  display: inline-block;
  width: 10px;
  height: 20px;
  margin: 30px 20px;
  background: #ee3029;

  @media (max-width: ${mobile.max}px) {
    width: 7px;
    height: 15px;
    margin: 8px 10px;
  }
`;

export const ShareBtn = styled.a`
  height: 49px;
  width: 190px;
  border: 1px solid #e3e0e0;
  margin: 32px auto;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1.12px;
  line-height: 50px;
  text-align: center;
  text-decoration: none;
  display: block;
`;



// WEBPACK FOOTER //
// ./src/components/countdown/styles/countdown.style.js